import { createSlice } from '@reduxjs/toolkit';

const initialState={
    screenusers:null
}
export const screenusersSlice = createSlice({
  name: 'screenusers',
  initialState,
  reducers: {

    
      
      setScreenuser: (state, action) => {
        state.screenusers = action.payload;
        
      },
      setLogoutScreenuser: (state,action)=>{
      state.screenusers=null
    }
  },
});

export const {  setScreenuser,setLogoutScreenuser} = screenusersSlice.actions;

export default screenusersSlice.reducer;
